/**
 * A Unity-kapcsolat minimális felülete, amit a hívási helyek használnak.
 *
 * Két implementáció van mögötte: a WebGL `UnityInstance` (a Unity loader adja — strukturálisan
 * megfelel ennek, ezért a WebGL út érintetlen marad) és a `UnityEditorTransport` (dev bridge a
 * fejlesztő saját gépén futó Unity Editorhoz). A `SendMessage` szignatúrája szándékosan azonos a
 * Unity-ével, hogy a hívási helyeknek ne kelljen tudniuk, melyik van a másik végen.
 */
interface IUnityTransport {
    SendMessage(gameObjectName: string, methodName: string, message?: string): void;
}

export default IUnityTransport;
